export default __webpack_public_path__ + "static/media/mtr.dad00499.png";